import * as Constants from './constants'
import * as Types from './types'

export const successConstant = (prefix: Types.RequestActionPrefix) => `${prefix}_${Constants.SUCCESS}`
export const errorConstant = (prefix: Types.RequestActionPrefix) => `${prefix}_${Constants.ERROR}`
export const requestConstant = (prefix: Types.RequestActionPrefix) => `${prefix}_${Constants.REQUEST}`
